export const templates_sv = {
  'pick_template' : 'Välj en mall eller skapa en egen',
  'informationmeeting' : 'Informationsmöte',
  'create_agenda' : 'Skapa en egen agenda',
  'agenda_template' : 'Agenda mall',
  'content' : 'Innehåll',
  'choose_template' : 'Välj mallen',

  'one_description' : '1:1 är medarbetarnas tid med sin ledare. Här finns möjligheten för medarbetaren att lyfta det som ligger top-of-mind just nu, samt ledarens möjlighet att ge eventuellt stöd i och hjälp i det. Mallen ger ett förslag på struktur, men går att ändra utefter behov.',
  'one_headline_1' : 'Ledarens 3',
  'one_point_1_1' : 'Hur är det?',
  'one_point_1_2' : 'Något speciellt du vill prata om idag?',
  'one_point_1_3' : 'Något du behöver stöd/hjälp med?',
  'one_headline_2' : 'Medarbetarens 3',
  'one_point_2_1' : 'Ämne 1',
  'one_point_2_2' : 'Ämne 2',
  'one_point_2_3' : 'Ämne 3',

  'fifty_description' : 'En promenad för två där tiden delas upp på två lika delar för att ge möjlighet att prata utan att bli avbruten och ge stöd till den andra att verkligen lyssna. Båda ges möjlighet att både prata och lyssna. Ställ ett larm som ringer efter halva tiden som stöd, för när det är dags att byta.',
  'fifty_headline_1' : 'Intro',
  'fifty_point_1_1' : 'Vem som börjar?',
  'fifty_point_1_2' : 'Har ni ett specifikt ämne eller är det fritt?',
  'fifty_point_1_3' : 'Vart ni ska gå och hur lång tid har ni på er?',
  'fifty_point_1_4' : 'Ställ in larm för halva tiden',
  'fifty_headline_2' : 'Del 1: en pratar och den andra lyssnar',
  'fifty_point_2_1' : 'Ämne',
  'fifty_headline_3' : 'Del 2: den andra pratar och den första lyssnar',
  'fifty_point_3_1' : 'Ämne',
  'fifty_headline_4' : 'Avslut',
  'fifty_point_4_1' : 'Tack för att du lyssnat, tack för att du delade med dig',
  'fifty_point_4_2' : 'Något vi önskar ta med oss från detta',

  'rdd_description' : 'En metod för att lösa problem genom att en person får prata av sig till en annan som lyssnar. Den som lyssnar kommer inte med några egna kommentarer eller tankar, och fungerar precis som en gummi-anka. Genom att formulera sin utmaning ser prataren ofta sin egen lösning.',
  'rdd_headline_1' : 'Intro (5 min)',
  'rdd_point_1_1' : 'Bestäm vem som håller tiden, förslagsvis lyssnaren',
  'rdd_point_1_2' : 'Välj vem som tar riktning, om ni går tillsammans',

  'rdd_headline_2' : 'Debugga',
  'rdd_point_2_1' : 'Pratare - Börja beskriv ditt problem',
  'rdd_point_2_2' : 'Lyssnare - Lyssnar och håller tiden',

  'rdd_headline_3': 'Frågor att fundera på',
  'rdd_point_3_1' : 'Vad är problemet?',
  'rdd_point_3_2' : 'Hur får problemet dig att må?',
  'rdd_point_3_3' : 'Har du en tanke om lösning?',
  'rdd_point_3_4' : 'Finns det något annat sätt att lösa problemet?',
  'rdd_point_3_5' : 'Vad behövs för att du ska komma framåt?',

  'rdd_headline_4' : 'Avslut (10 min)',
  'rdd_point_4_1' : 'Tidsansvarig flaggar för att det är dags att avrunda',
  'rdd_point_4_2' : 'Prataren sammanfattar själv insikter',
  'rdd_point_4_3' : 'Bestäm om det behövs ett nytt möte och med vem',
  'rdd_point_4_4' : 'Tacka för varandras tid',

  'info_description' : 'Ett möte där deltagarna är ute och promenerar medan en ansvarig modererar, delar information och för eventuella anteckningar. Varva gärna vem som är ansvarig när ni gör flera möten av detta slag.',
  'info_headline_1' : 'Dagens agenda',
  'info_point_1_1' : 'Ämne 1',
  'info_point_1_2' : 'Ämne 2',
  'info_point_1_3' : 'Ämne 3',
  'info_headline_2' : 'Avslut',
  'info_point_2_1' : 'Dela anteckning med hela gruppen',

  'stand_description' : 'En daglig kort avstämning där var och en för chans att lyfta tre punkter: vad som gjorts från gruppens förra stand-up, vad planen är för dagen, och om någon hjälp eller input behövs från någon annan för att komma vidare. Syftet är att hjälpa var och en att innan mötet reflektera och sammanfatta vad som gjorts, samt prioritera för dagen.',
  'stand_headline_1' : 'Förslag: Den som kom till mötet sist börjar',
  'stand_point_1_1' : 'Vad gjorde du igår?',
  'stand_point_1_2' : 'Vad planerar du att göra idag?',
  'stand_point_1_3' : 'Behöver du hjälp med något?',
  'stand_point_1_4' : 'Lämna ordet till en kollega',
  'stand_headline_2' : 'Nästa person svarar på samma frågor osv'
}